import o from "./_group.js";
var r = o(function (o, r, t) {
  o[t ? 0 : 1].push(r);
}, !0);
export { r as default };